// firebase.js
import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, onAuthStateChanged, sendPasswordResetEmail, updateProfile } from 'firebase/auth';
import { initializeFirestore, doc, setDoc, getDoc, collection, getDocs, deleteDoc, updateDoc } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyA8F5IM0Aso28PoQ6EWrPYddyTUgkwsmpA",
  authDomain: "tenekkapp.firebaseapp.com",
  databaseURL: "https://tenekkapp-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "tenekkapp",
  storageBucket: "tenekkapp.firebasestorage.app",
  messagingSenderId: "1082510895516",
  appId: "1:1082510895516:web:198482c3b1ded711624059",
  measurementId: "G-D1NXJHTY5Z"
};

const app = initializeApp(firebaseConfig);

// Analytics can throw on some mobile browsers (Brave, Safari private, ad-blockers)
try { getAnalytics(app); } catch (_) {}

export const auth = getAuth(app);
// ignoreUndefinedProperties: Firestore rejects undefined values; this strips them automatically
export const db = initializeFirestore(app, { ignoreUndefinedProperties: true });

export const registerUser = async (email, password, displayName) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    await updateProfile(userCredential.user, { displayName });
    await setDoc(doc(db, "users", userCredential.user.uid), {
      email,
      displayName,
      createdAt: new Date().toISOString()
    });
    return { success: true, user: userCredential.user, displayName };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const updateDisplayName = async (user, displayName) => {
  await updateProfile(user, { displayName });
  await setDoc(doc(db, 'users', user.uid), { displayName }, { merge: true });
};

export const loginUser = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const snap = await getDoc(doc(db, 'users', userCredential.user.uid));
    const displayName = snap.exists() ? snap.data().displayName : null;
    return { success: true, user: userCredential.user, displayName };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const logoutUser = async () => {
  try {
    await signOut(auth);
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const resetPassword = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// ─── Vendor helpers ───────────────────────────────────────────────────────────

export const getVendors = async () => {
  try {
    const snap = await getDocs(collection(db, 'vendors'));
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  } catch (_) {
    return [];
  }
};

export const addVendor = async (vendorData) => {
  try {
    const ref = doc(collection(db, 'vendors'));
    await setDoc(ref, { ...vendorData, createdAt: new Date().toISOString() });
    return { success: true, id: ref.id };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const updateVendor = async (vendorId, data) => {
  try {
    await updateDoc(doc(db, 'vendors', vendorId), data);
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const deleteVendor = async (vendorId) => {
  try {
    await deleteDoc(doc(db, 'vendors', vendorId));
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};